import httpClientService from '@/services/httpClientService'

export default class productService {
  static async getProductSpecifications() {
    return httpClientService.getAPIHttpClient().get(`${process.env.VUE_APP_INTERNAL_API}products`)
  }

  /**
   * @param {number} brandId
   *
   * @returns {Promise<{ data: Array<{text: string, value: string}>}>}
   */
  static async fetchProductsByBrandId(brandId) {
    return httpClientService.getAPIHttpClient().get(`${process.env.VUE_APP_INTERNAL_API}products/brand/${brandId}`)
  }
}
